import { render, staticRenderFns } from "./breadcrumbsFoot.vue?vue&type=template&id=4ee669bf&scoped=true&"
import script from "./breadcrumbsFoot.vue?vue&type=script&lang=js&"
export * from "./breadcrumbsFoot.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumbsFoot.vue?vue&type=style&index=0&id=4ee669bf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee669bf",
  null
  
)

export default component.exports